module.exports = __webpack_public_path__ + "img/image14.10e4672b.png";